module.exports = __webpack_public_path__ + "static/media/k3-texture.558920e5.jpg";